import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: true
})
export class TruncatePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): number {
    if (value === null || value === undefined) {
      return 0
    }

    const num = Number(value);
    if (isNaN(num)) {
      return 0;
    }

    return num < 0 ? Math.ceil(num) : Math.floor(num);
  }

}
